import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import SysDepartModal from "./modules/DepartModal";
/*  import { filterObj } from '@/utils/util'
  , queryByFactories*/

import { queryDepartTreeList } from '@/api/api';
import { deleteAction } from '@/api/manage'; // 表头

var columns = [{
  title: '机构名称',
  dataIndex: 'departName'
}, {
  title: '机构类型',
  align: "center",
  dataIndex: 'orgType'
}, {
  title: '机构编码',
  dataIndex: 'orgCode'
}, {
  title: '手机号',
  dataIndex: 'mobile'
}, {
  title: '传真',
  dataIndex: 'fax'
}, {
  title: '地址',
  dataIndex: 'address'
}, {
  title: '排序',
  align: 'center',
  dataIndex: 'departOrder'
}, {
  title: '操作',
  align: "center",
  dataIndex: 'action',
  scopedSlots: {
    customRender: 'action'
  }
}];
export default {
  name: "DepartList2",
  components: {
    SysDepartModal: SysDepartModal
  },
  data: function data() {
    return {
      description: 'jeecg 生成SysDepart代码管理页面',
      // 查询条件
      queryParam: {},
      //数据集
      factories: '',
      dataSource: [],
      columns: columns,
      // 分页参数

      /*        ipagination:{
                current: 1,
                pageSize: 5,
                pageSizeOptions: ['5', '10', '20'],
                showTotal: (total, range) => {
                  return range[0] + "-" + range[1] + " 共" + total + "条"
                },
                showQuickJumper: true,
                showSizeChanger: true,
                total: 0
              },*/
      isorter: {
        column: 'createTime',
        order: 'desc'
      },
      loading: false,
      selectedRowKeys: [],
      selectedRows: [],
      url: {
        list: "/sysdepart/sysDepart/list",
        delete: "/sysdepart/sysDepart/delete",
        deleteBatch: "/sysdepart/sysDepart/deleteBatch"
      }
    };
  },
  created: function created() {
    this.loadData();
  },
  methods: {
    loadData: function loadData() {
      var _this = this;

      this.dataSource = [];
      queryDepartTreeList().then(function (res) {
        if (res.success) {
          _this.dataSource = res.result;
        }
      });
    },
    getQueryField: function getQueryField() {
      //TODO 字段权限控制
      var str = "id,";

      for (var a = 0; a < this.columns.length; a++) {
        str += "," + this.columns[a].dataIndex;
      }

      return str;
    },
    onSelectChange: function onSelectChange(selectedRowKeys, selectionRows) {
      this.selectedRowKeys = selectedRowKeys;
      this.selectionRows = selectionRows;
    },
    onClearSelected: function onClearSelected() {
      this.selectedRowKeys = [];
      this.selectionRows = [];
    },
    //TODO getQueryParams
    handleDelete: function handleDelete(id) {
      var that = this;
      deleteAction(that.url.delete, {
        id: id
      }).then(function (res) {
        if (res.success) {
          that.$notification.success({
            message: res.message
          });
          that.loadData();
        } else {
          that.$notification.warning({
            message: res.message
          });
        }
      });
    },
    handleDetail: function handleDetail(record) {
      this.$refs.sysDepartModal.edit(record);
      this.$refs.sysDepartModal.title = "详情";
      this.$refs.sysDepartModal.disableSubmit = true;
    },
    batchDel: function batchDel() {
      if (this.selectedRowKeys.length <= 0) {
        this.$message.warning('请选择一条记录！');
        return;
      } else {
        var ids = "";

        for (var a = 0; a < this.selectedRowKeys.length; a++) {
          ids += this.selectedRowKeys[a] + ",";
        }

        var that = this;
        this.$confirm({
          title: "确认删除",
          content: "是否删除选中数据?",
          onOk: function onOk() {
            deleteAction(that.url.deleteBatch, {
              ids: ids
            }).then(function (res) {
              if (res.success) {
                that.$notification.success({
                  message: res.message
                });
                that.loadData();
                that.onClearSelected();
              } else {
                that.$notification.warning({
                  message: res.message
                });
              }
            });
          }
        });
      }
    },
    handleEdit: function handleEdit(record) {
      this.$refs.sysDepartModal.edit(record);
      this.$refs.sysDepartModal.title = "编辑";
    },
    handleAdd: function handleAdd() {
      this.$refs.sysDepartModal.add();
      this.$refs.sysDepartModal.title = "新增";
    },
    handleTableChange: function handleTableChange(pagination, filters, sorter) {
      //分页、排序、筛选变化时触发
      console.log(sorter); //TODO 筛选

      if (Object.keys(sorter).length > 0) {
        this.isorter.column = sorter.field;
        this.isorter.order = "ascend" == sorter.order ? "asc" : "desc";
      }
      /*this.ipagination = pagination;*/


      this.loadData();
    },
    modalFormOk: function modalFormOk() {
      // 新增/修改 成功时，重载列表
      this.loadData();
    }
  }
};